const mainBannerTypes =  {
    FETCH_MAINBANNER_START : 'FETCH_MAINBANNER_START',
    FETCH_MAINBANNER_SUCCESS : 'FETCH_MAINBANNER_SUCCESS',
    FETCH_MAINBANNER_FAILURE : 'FETCH_MAINBANNER_FAILURE',
}

export default mainBannerTypes;